/* ARRAY cart drawer extras - the two buttons and the button's own label.

   SELECTION IS CSS. The bundle cards are labels around real checkboxes, so
   ticking and the ring come from :checked with this file blocked; all this does
   is read which boxes are ticked when the button is pressed, and add those
   variants in ONE request.

   THE LABEL FOLLOWS THE TICKS: one card selected says "Add item", two says
   "Add both", none disables the button. The three strings are data attributes
   on the button itself, written by Liquid, so this file never invents copy and
   the wording is changed in one place.

   IT SPEAKS HORIZON: /cart/add.js with every cart-items-component's section id,
   then a cart:update event in the shape the theme's own product form
   dispatches. That is what makes the drawer re-render - and because the extras
   are rendered inside that same section, the offer rebuilds itself from the new
   cart in the same paint: what was just added drops out of the list.

   NOTHING IS BOUND TO AN ELEMENT. Everything is delegated on document, because
   the drawer's markup is replaced wholesale on every cart change - a listener
   attached to a button would be pointing at a node that no longer exists after
   the first add. Same reason the label is refreshed on 'change' and again after
   every cart update. */
(function () {
  if (window.__bdCart) return;
  window.__bdCart = true;

  function sectionIds() {
    var ids = [];
    var comps = document.querySelectorAll('cart-items-component');
    for (var i = 0; i < comps.length; i++) if (comps[i].dataset && comps[i].dataset.sectionId) ids.push(comps[i].dataset.sectionId);
    return ids;
  }

  function announce(qty, sections, productId) {
    try {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: {}, sourceId: 'beyondads-cart', data: { source: 'product-form-component', itemCount: qty, productId: productId || null, sections: sections || {} } }
      }));
    } catch (e) { /* no event, no re-render - the add still happened */ }
  }

  function relabel(root) {
    var btn = root.querySelector('[data-bc-add-both]');
    if (!btn || btn.__busy) return;
    var boxes = root.querySelectorAll('[data-bc-box]');
    var on = 0;
    for (var i = 0; i < boxes.length; i++) if (boxes[i].checked) on++;
    var label = btn.querySelector('[data-bc-both-t]');
    if (label) {
      label.textContent = on > 1
        ? (btn.getAttribute('data-both') || 'Add both')
        : on === 1
          ? (btn.getAttribute('data-one') || 'Add item')
          : (btn.getAttribute('data-none') || 'Select an item');
    }
    btn.disabled = on === 0;
  }
  function relabelAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bc-root]'), relabel);
  }

  function add(items, btn, label) {
    if (!items.length || (btn && btn.__busy)) return;
    var was = label ? label.textContent : '';
    if (btn) { btn.__busy = true; btn.disabled = true; }

    var body = { items: items };
    var ids = sectionIds();
    if (ids.length) { body.sections = ids.join(','); body.sections_url = window.location.pathname; }

    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (!res || res.status >= 400 || res.errors) {
          if (label) label.textContent = 'Not available';
          setTimeout(function () {
            if (label) label.textContent = was;
            if (btn) { btn.__busy = false; btn.disabled = false; }
          }, 1800);
          return;
        }
        announce(items.length, res.sections);
        if (btn) btn.__busy = false;
        setTimeout(relabelAll, 60);
      })
      .catch(function () { if (btn) { btn.__busy = false; btn.disabled = false; } });
  }

  document.addEventListener('change', function (e) {
    if (!e.target.closest) return;
    var root = e.target.closest('[data-bc-root]');
    if (root && e.target.matches('[data-bc-box]')) relabel(root);
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var root = e.target.closest('[data-bc-root]');
    if (!root) return;

    var both = e.target.closest('[data-bc-add-both]');
    if (both) {
      e.preventDefault();
      var items = [];
      Array.prototype.forEach.call(root.querySelectorAll('[data-bc-box]'), function (box) {
        if (box.checked) items.push({ id: parseInt(box.getAttribute('data-vid'), 10), quantity: 1 });
      });
      add(items, both, both.querySelector('[data-bc-both-t]'));
      return;
    }

    var plus = e.target.closest('[data-bc-add]');
    if (plus) {
      e.preventDefault();
      var id = parseInt(plus.getAttribute('data-vid'), 10);
      if (!id) return;
      plus.classList.add('is-done');
      add([{ id: id, quantity: 1 }], plus, null);
    }
  });

  document.addEventListener('cart:update', function () { setTimeout(relabelAll, 60); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', relabelAll);
  else relabelAll();
})();
